<template>
	<div class="instructions-view">
		<div class="instr" v-for="(instr, i) in value" v-bind:key="i">
			<div class="title">{{ _instructions[i].label }}</div>
			<textarea v-model="value[i]" />
			<div class="buttons">
				<div @click="remove(i)">Fjern</div>
			</div>
		</div>
		<div class="btn" @click.stop="add">Tilføj</div>
	</div>
</template>

<script>
	import ContextPopupView from './ContextPopupView'

	export default {
		data() {
			return {
				instructions: []
			};
		},
		props: {
			value: {
				type: Object,
				default() {
					return {};
				}
			}
		},
		computed: {
			_instructions() {
				var r = {};

				for (var i = 0; i < this.instructions.length; ++i) {
					r[this.instructions[i].name] = this.instructions[i];
				}

				return r;
			},
			_actions() {
				var r = [];
				var self = this;

				for (var i = 0; i < this.instructions.length; ++i) {
					r.push({
						label: self.instructions[i].label,
						action: (function () {
							var j = i;

							return function () {
								var value = Object.assign({}, self.value);

								value[self.instructions[j].name] = '';

								self.$emit('input', value);
							}
						})()
					});
				}

				return r;
			}
		},
		methods: {
			add(event) {
				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: this._actions
				});
			},
			remove(name) {
				var value = Object.assign({}, this.value);

				delete value[name];

				this.$emit('input', value);
			}
		},
		created() {
			

			var self = this;

			// Get employees
			this.axios
				.get('/tasks/instructions/')
				.then(function (r) {
					

					self.instructions = r.data._items;
				});
		}
	}
</script>

<style lang="scss" scoped>
	.instructions-view {
		& > .instr {
			position: relative;
			border: 1px solid #2d2f36;
			line-height: 40px;
			text-align: left;
			padding-left: 10px;
			padding-right: 10px;
			margin-bottom: 10px;

			& > textarea {
				background-color: #202127;
				width: 100%;
				height: 50px;
				color: white;
				padding: 10px;
				font-size: 12px;
			}

			& > .props {
				line-height: 12px;

				& > div {
					font-size: 12px;
					margin-right: 10px;
					cursor: pointer;
					margin-bottom: 10px;
				}
			}

			& > .buttons {
				position: absolute;
				top: 0;
				right: 0;

				& > div {
					display: inline-block;
					margin-right: 15px;
					font-size: 12px;
					cursor: pointer;
				}
			}
		}

		& > .btn {
			background-color: #202127;
			line-height: 40px;
			text-align: center;
			margin-bottom: 10px;
			cursor: pointer;
		}
	}
</style>